<template>
    <div class="max-w-2xl mx-auto bg-white p-6 rounded-lg">
        <h2 class="text-xl font-bold text-red-600">
            ACTION 0%* (sans acompte)
        </h2>
        <p class="text-sm font-semibold text-gray-700 mt-2">
            Attention, emprunter de l’argent coûte aussi de l’argent
        </p>
        <p class="text-gray-600 text-sm mt-2">
            * Offre de prêt à tempérament, valable du
            <strong>19/02/2025 au 19/02/2026</strong>, applicable pour un
            montant emprunté de minimum 500 € et maximum 5 000 € et pour une
            durée de remboursement de 6 à 36 mois. Les conditions et la durée de
            validité de l’offre peuvent être adaptée à tout moment par Cofidis.
            Sous réserve d’acceptation de votre demande par Cofidis et après
            signature de votre contrat de crédit.
        </p>
        <p class="text-gray-600 text-sm mt-2">
            Sous réserve d’acceptation de votre demande par Cofidis et après
            signature de votre contrat de crédit. Exemple : Le Taux Annuel
            Effectif Global fixe : 0% (taux débiteur annuel actuariel fixe : 0%)
            pour un prêt à tempérament de 4200 € pour une durée de 24 mois avec
            24 mensualités de 175 €, pour un montant total à rembourser de 4200
            €. Le taux annuel effectif global fixe peut différer suivant le
            montant du crédit, la durée du contrat de crédit, les modalités de
            prélèvement ou de paiement choisies. TAEG en vigueur à partir du
            01/06/2023.
        </p>
        <p class="text-gray-600 text-sm mt-2">
            Cofidis SA, prêteur et agent en assurances, Chaussée de Lille 422 A,
            7501 ORCQ – TVA BE0400.359.283
        </p>
        <p class="text-gray-600 text-sm mt-2">
            ER : KAMEO Bikes. Intermédiaire de crédit. 22 Quai De Rome 4000
            Liège – TVA BE 0681.879.712
        </p>
    </div>

    <div class="max-w-2xl mx-auto bg-white p-6 rounded-lg mt-6">
        <h2 class="text-xl font-bold text-red-600">
            ACTION 0%* (avec acompte)
        </h2>
        <p class="text-sm font-semibold text-gray-700 mt-2">
            Attention, emprunter de l’argent coûte aussi de l’argent
        </p>
        <p class="text-gray-600 text-sm mt-2">
            * Offre de prêt à tempérament, valable du
            <strong>19/02/2025 au 19/02/2026</strong>, applicable pour un
            montant emprunté de minimum 500 € et maximum 5 000 € et pour une
            durée de remboursement de 6 à 36 mois. Les conditions et la durée de
            validité de l’offre peuvent être adaptée à tout moment par Cofidis.
            Sous réserve d’acceptation de votre demande par Cofidis et après
            signature de votre contrat de crédit.
        </p>
        <p class="text-gray-600 text-sm mt-2">
            Sous réserve d’acceptation de votre demande par Cofidis et de la
            signature de votre contrat de crédit. Exemple : pour un vélo dont le
            prix comptant est de 5499,00€, vous versez un acompte de 1179,00€,
            puis financez le solde grâce à un prêt à tempérament de 4320,00€
            pour une période de 36 mois avec 36 mensualités de 120€, à un taux
            annuel effectif global (TAEG) fixe de 0% (taux actuariel annuel fixe
            : 0%), pour un montant total à rembourser de 4320,00€, hors acompte.
            Le taux annuel effectif global fixe peut différer suivant le montant
            du crédit, la durée du contrat de crédit, les modalités de
            prélèvement ou de paiement choisies. TAEG en vigueur à partir du
            01/06/2023.
        </p>
        <p class="text-gray-600 text-sm mt-2">
            Cofidis SA, prêteur et agent en assurances, Chaussée de Lille 422 A,
            7501 ORCQ – TVA BE0400.359.283
        </p>
        <p class="text-gray-600 text-sm mt-2">
            ER : KAMEO Bikes. Intermédiaire de crédit. 22 Quai De Rome 4000
            Liège – TVA BE 0681.879.712
        </p>
    </div>
</template>
